import { IonButton, IonCard, IonCol, IonIcon, IonRow, IonText } from "@ionic/react"
import { cardOutline } from "ionicons/icons"
import { passToWebView } from "../../../library/Funcs"

interface Props {
    eventsPay: []
}

const EventsPay: React.FC<Props> = (props) => {
    const payTourHandler = (e: any, link: string) => {
        e.preventDefault();
        
        passToWebView("sendPayment", link);
    }

    return <>
    {props.eventsPay !== undefined ?
        <IonCard>
          {props.eventsPay?.map((item: any) => {
            return <IonRow className="selector-container">
              <IonCol size="12">
                <form onSubmit={(e) => payTourHandler(e, item.link)}>
                    <IonButton type="submit" expand='block'>
                    <IonText>پرداخت هزینه {item.title}</IonText>
                    <IonIcon slot="start" icon={cardOutline} />
                    </IonButton>
                </form>
              </IonCol>
            </IonRow>})
          }
        </IonCard>
    : null}
    </>
}

export default EventsPay